<template>
  <div>
    <div class="button-item mt-1">
      <router-link
        :to="{ name: 'Edit Properties', params: { id: getId(), userId:getUserId(),typeEntityId:gettypeEntityId(),propertyName:getpropertyName() }}"
      >
        <feather-icon icon="EditIcon" svgClasses="h-5 w-5" class="cursor-pointer"></feather-icon>
      </router-link>
    </div>
    <div class="button-item mt-1">
      <feather-icon
        @click="popupActive = true"
        icon="XCircleIcon"
        svgClasses="h-5 w-5 ml-5"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-popup
      classContent="popup-example"
      :title="$t('areYouSureDelete')"
      :active.sync="popupActive"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center">
            <vs-button @click="remove(getId())" color="danger">Evet</vs-button>
            <vs-button @click="popupActive = false" style="margin-left:75px">Hayır</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import http from "../../../../http/http-helper";
import notify from "../../../../shared/toast";

export default Vue.extend({
  props: ["id", "typeEntityId", "propertyName", "userId"],
  data() {
    return {
      popupActive: false
    };
  },
  methods: {
    getId() {
      return this.id;
    },
    gettypeEntityId() {
      return this.typeEntityId;
    },
    getpropertyName() {
      return this.propertyName;
    },
    getUserId() {
      return this.userId;
    },
    remove(id) {
      http.post(`/properties/delete?propertyId=${id}`).then(response => {
        this.popupActive = false;
        notify.success(this.$t("removed"));

        this.$emit("refresh");
      });
      /*   .catch(err => {
          this.popupActive = false;
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("errorwhenremove"),
            color: "danger"
          });
        });*/
    }
  }
});
</script>

<style lang="scss" scoped>
.button-item {
  display: inline-block;
}
</style>
